import React, { useState } from 'react'
const ABC = () => {
  let [ABC, setABC] = useState(0)
  const [EFG, setEFG] = useState(0)
  const [HIJ, setHIJ] = useState(0)
  const KLM = () => { 
    setEFG(EFG+1)
    setABC(ABC+1)
  } 
  const OPQ = () => { 
    if(EFG>0){
      setEFG(EFG-1)
      setABC(ABC-1)
    }
  } 
  const RST = () => { 
    setHIJ(HIJ+1)
    setABC(ABC+2)
  } 
  const UVW = () => { 
    if(HIJ>0){
      setHIJ(HIJ-1)
      setABC(ABC-2)
    }
  } 
  return (
    <>
    <div className='flex justify-between w-[140px] text-[9px]'>
      <p>Item1 $1 x {EFG}</p>
      <div><button className='item-count-btn' onClick={OPQ} style={{background:EFG==0?'rgb(108, 108, 108)':''}} disabled={EFG==0}>-</button><button className='item-count-btn' value='123' onClick={KLM}>+</button></div> 
    </div>
    <div className='flex justify-between w-[140px] text-[9px]'>
    <p>Item2 $2 x {HIJ}</p>
    <div><button className='item-count-btn' onClick={UVW}  style={{background:HIJ==0?'rgb(108, 108, 108)':''}} disabled={HIJ==0}>-</button><button className='item-count-btn' value='123' onClick={RST}>+</button></div> 
    </div>
    <div className='flex justify-end w-[140px] text-[9px]'>
      Total:${ABC}
    </div>
    </>
  )
}
export default ABC
